"use client"
import { User } from "lucide-react";
import { getTriageLevelColor } from "./utils";

export default function PatientOverview({ patientOverview }) {
    if (!patientOverview) return null;

    return (
        <div className="pt-2">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                <User className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                Patient Overview
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
                {patientOverview.demographics && (
                    <div>
                        <p className="text-sm text-gray-500 mb-1">Demographics</p>
                        <p className="text-sm font-medium text-gray-800">{patientOverview.demographics}</p>
                    </div>
                )}
                {patientOverview.chief_complaint && (
                    <div>
                        <p className="text-sm text-gray-500 mb-1">Chief Complaint</p>
                        <p className="text-sm font-medium text-gray-800 capitalize">{patientOverview.chief_complaint}</p>
                    </div>
                )}
                {patientOverview.triage_level && (
                    <div>
                        <p className="text-sm text-gray-500 mb-1">Triage Level</p>
                        <span className={`inline-block px-3 py-1 rounded-md text-sm font-medium border ${getTriageLevelColor(patientOverview.triage_level)}`}>
                            {patientOverview.triage_level}
                        </span>
                    </div>
                )}
                {patientOverview.care_setting && (
                    <div>
                        <p className="text-sm text-gray-500 mb-1">Care Setting</p>
                        <span className="inline-block px-3 py-1 rounded-md text-sm font-medium bg-gray-100 text-gray-800 border border-gray-300">
                            {patientOverview.care_setting}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
